export interface ProductMultiSelectProps {
  products: { id: string; name: string }[];
  value: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
}

// Lista de seleção múltipla de produtos, extraída do StartProductionDialog
// para reuso no formulário de Ordem de Produção. Controlado por `value`/`onChange`.
export function ProductMultiSelect({
  products,
  value,
  onChange,
  disabled,
}: ProductMultiSelectProps) {
  function toggle(id: string) {
    onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  }
  return (
    <div className="max-h-40 overflow-y-auto rounded-md border bg-card">
      {products.length === 0 ? (
        <p className="p-3 text-xs text-muted-foreground">Nenhum produto cadastrado.</p>
      ) : (
        products.map((p) => (
          <label
            key={p.id}
            className="flex cursor-pointer items-center gap-2 border-b px-3 py-2 text-sm last:border-0 hover:bg-muted/40"
          >
            <input
              type="checkbox"
              checked={value.includes(p.id)}
              onChange={() => toggle(p.id)}
              disabled={disabled}
              className="h-4 w-4"
            />
            {p.name}
          </label>
        ))
      )}
    </div>
  );
}
